module.exports = "../../assets/fonts/appspace-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asNavBar/images/appspace-logo.svg
// module id = 263
// module chunks = 0